module.exports = __webpack_public_path__ + "img/is.e478944c.svg";